module.exports = __webpack_public_path__ + "img/IntelligenceIndustrialSolutions.8cc10b10.jpg";